var _defs, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCandelchartDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("image", {
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAdVJREFUeF7tWm1uxSAMe73WtO3y2661rmhUqqpCTDBQVE/ar/KROLYDfV3WdX09+W8RAGKAJDCbBfxsAf9u/x+MwGf0gJ2yiwAgICAGTNgGJYHIfHkAwQJe8gB5wHxHYZmgTPAfAXUBdQECAqk2SL1xZeL07NPFBKmbZADw7OOZkwwhxQDqJgIgjQACdJDJmyH3b+8LkhkYgL6zy7XFpNfMBEAqQYRFyTECIF6Gmuqs0gStCl89h/PZGdBUZwMAgPM5A9BEZwMBMPMRANEDPDo7F9ZaI4yHtXlY3Fr36jk8pzcDYG3OAMDtqukBrYYBt6vmKABMp/UEdjHHuv0f4+jiAfAmlQB8bfPfjezDmE/PPgwJtGaAp9vAxREAp3NAE515qEk6PZr57AxoqrMBAMD51FyHYZ0NAAD2DQGQ+HE0UChU+NhaYFTjwNwZ3dRmZgASGxxrzc/jHgnA2rQQKnxe/EoMWd9zFIYrgwRQMKYJAIxqWiwqyDE7tAkAjGp69OwBJblPjQcwAPAkQ50jAIjfCPXSsxjAREASkAR4n8nJA6I2KV9vMXWeW0seIA+QB6CXOlOVMsGnm2Cvm51JxZIBzC5Qsu9txgoAYhu8TVVLAnk8A/4AZqCZkLpvUREAAAAASUVORK5CYII="
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "icons8-chart-64",
    width: 30,
    height: 30,
    fill: "url(#pattern)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandelchartDown);
export default __webpack_public_path__ + "static/media/candelchartDown.b81bab1aaa4c8722e5ef25062995bb49.svg";
export { ForwardRef as ReactComponent };